/* @flow */
import ChatMembership from 'entities/ChatMembership';
import Collection from 'lib/Collection';

class ChatMemberships extends Collection {
  initialize() {
    this.model = ChatMembership;
  }
}

export default ChatMemberships;



// WEBPACK FOOTER //
// ./src/collections/ChatMemberships.js